// Lightweight entry point - checks browser compatibility before loading the app
// This prevents SDK initialization (Datadog, Analytics) in unsupported browsers

const rootElement = document.getElementById('root');

// Only load the app for supported browsers
// The fallback flag is set by the inline script in index.html for unsupported browsers
if (rootElement && rootElement.dataset.fallback !== 'true') {
  import('./app-init')
    .then(({ initializeApp }) => {
      initializeApp(rootElement);
    })
    .catch((error) => {
      // Show error UI if app fails to load
      console.error('Failed to load application:', error);
      rootElement.innerHTML = `
        <div style="font-family: -apple-system, BlinkMacSystemFont, Inter, sans-serif;
          min-height: 100vh; display: flex; align-items: center; justify-content: center;
          padding: 20px; box-sizing: border-box;">
          <div style="text-align: center; max-width: 500px;">
            <h1 style="color: #1a1a1a; font-size: 24px; margin-bottom: 24px;">
              Something went wrong
            </h1>
            <p style="color: #666; font-size: 16px; line-height: 1.5;">
              We encountered an error loading the application. Please refresh the page or try again later.
            </p>
            <button onclick="location.reload()" style="margin-top: 24px; padding: 12px 24px;
              background: #0066cc; color: white; border: none; border-radius: 8px;
              font-size: 16px; cursor: pointer;">
              Refresh Page
            </button>
          </div>
        </div>
      `;
    });
}
